import React from "react";
import { SSH_FeatureHandler } from "../../../../helpers/FeatureHandler.helper";
import V1 from "./v1/HeadlineV1.component";

const featureName = "blockPLPHeadline";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const SSH_PlpHeadline = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <SSH_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

SSH_PlpHeadline.displayName = "SSH_PlpHeadline";
